import { Component, Input } from '@angular/core';
import { Modal } from 'bootstrap';

import { MapService } from '../map.service';

@Component({
	selector: 'app-map-stops',
	templateUrl: './map-stops.component.html',
	styleUrls: ['./map-stops.component.css'],
})
export class MapStopsComponent {
	data: Array<any> = [];
	private type = '';
	@Input() stops: Array<any> = [];

	constructor(private readonly service: MapService) {}

	select(item): void {
		this.service.stopToggle({
			type: this.type,
			data: item,
		});
	}

	open(type: string): void {
		this.type = type;
		this.data = this.stops.filter((obj) => obj.type == type);
		new Modal(document.getElementById('mapStops')).show();
	}

	close(): void {
		const modal = Modal.getInstance(document.getElementById('mapStops'));
		if (!modal) {
			return;
		}
		modal.close();
	}
}
